import React, { useEffect, useState } from "react"
import PlusMinusInput from "../form/plus-minus-input"
import { Switch } from "@headlessui/react"

export default function PricingCalculatorComponent({ pricing }) {
  const {
    trialLink,
    demoLink,
    stripePriceIdPlan,
    basePrice,
    privacyAndSsoPrice,
    privacyAndSsoStart,
    subscribersStart,
    subscriberIncrement,
    subscribersMinimum,
    subscribersMaximum,
    subscribersPriceIncrement,
    pagesStart,
    pageIncrement,
    pagesMinimum,
    pagesMaximum,
    pagesPriceIncrement
  } = pricing

  const [subscribers, setSubscribers] = useState(subscribersStart)
  const [pages, setPages] = useState(pagesStart)
  const [price, setPrice] = useState(basePrice)
  const [privacy, setPrivacy] = useState(privacyAndSsoStart)
  const [link, setLink] = useState("")

  const updatePrice = ({ subscribers, pages, privacy }) => {
    const subscriberCost = ((subscribers / subscriberIncrement)
                            - (subscribersStart / subscriberIncrement))
                           * subscribersPriceIncrement
    const pageCost = ((pages / pageIncrement)
                      - (pagesStart / pageIncrement))
                     * pagesPriceIncrement
    const privacyCost = privacy ? privacyAndSsoPrice : 0

    setPrice(basePrice + subscriberCost + pageCost + privacyCost)
  }
  const buildLink = (link, { subscribers, pages, privacy }) => {
    return link
      .replace(/\[SUBSCRIBERS]/g, subscribers)
      .replace(/\[PAGES]/g, pages)
      .replace(/\[PRIVACY]/g, privacy)
      .replace(/\[STRIPE_PRICE_ID]/g, stripePriceIdPlan)
  }

  const showDemoAsPrice = subscribers === subscribersMaximum
                          || pages === pagesMaximum

  useEffect(() => {
    if (showDemoAsPrice) {
      setLink(buildLink(demoLink, { subscribers, pages, privacy }))
    } else {
      setLink(buildLink(trialLink, { subscribers, pages, privacy }))
    }
  }, [showDemoAsPrice, subscribers, pages, privacy])

  return (
    <div className="p-2 lg:mt-0 lg:w-full lg:max-w-xl lg:flex-shrink-0">
      <div
        className="mt-12 rounded-2xl bg-gray-900 py-6 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-8"
      >
        <div className="mx-auto max-w-md flex flex-col gap-y-8 px-8">

          <div className="h-[125px]">
            {showDemoAsPrice && (

              <div className="flex h-full items-center justify-center">
                <span className="text-3xl font-semibold tracking-tight text-white">
                  Speak with the team
                </span>
              </div>

            ) || (

               <div className="flex flex-col gap-y-8">
                 <p className="text-sm text-gray-300">
                   <span className="font-bold">7 day trial.</span> No credit card required.
                 </p>
                 <div className="flex items-center justify-center">
                   <div className="flex flex-col gap-y-2">
                     <p className="flex items-baseline justify-center gap-x-2">
                       <span className="text-base font-semibold leading-6 tracking-wide text-gray-200">
                         US
                       </span>
                       <span className="text-5xl font-bold tracking-tight text-white">
                         ${price}
                       </span>
                       <span className="text-base font-semibold leading-6 tracking-wide text-gray-200">
                         /mo
                       </span>
                     </p>
                     <p className="text-gray-400 text-xs">billed monthly</p>
                   </div>
                 </div>
               </div>

             )}
          </div>

          <div className="pt-8 pb-9 px-8 text-left bg-gray-700/80 flex flex-col gap-y-6 text-gray-200 rounded-xl">

          <div className="flex flex-col gap-y-2">
              <div className="text-sm">
                Status Pages
              </div>
              <PlusMinusInput
                value={pages}
                valueIncrement={pageIncrement}
                valueMinimum={pagesMinimum}
                valueMaximum={pagesMaximum}
                onUpdate={(pages) => {
                  setPages(pages)
                  updatePrice({ subscribers, pages, privacy })
                }}
              />
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="text-sm">
                Subscribers
              </div>
              <PlusMinusInput
                value={subscribers}
                valueIncrement={subscriberIncrement}
                valueMinimum={subscribersMinimum}
                valueMaximum={subscribersMaximum}
                onUpdate={(subscribers) => {
                  setSubscribers(subscribers)
                  updatePrice({ subscribers, pages, privacy })
                }}
              />
            </div>

            <div>
              <Switch.Group>
                <div className="flex items-center">
                  <Switch
                    checked={privacy}
                    onChange={(privacy) => {
                      setPrivacy(privacy)
                      updatePrice({ subscribers, pages, privacy })
                    }}
                    className={`${
                      privacy ? "bg-brand-600" : "bg-gray-400"
                    } relative inline-flex h-6 w-11 items-center rounded-full`}
                  >
                    <span className="sr-only">Include Privacy & SSO</span>
                    <span
                      className={`${
                        privacy ? "translate-x-6" : "translate-x-1"
                      } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                    />
                  </Switch>
                  <Switch.Label
                    className="ml-2 text-sm text-gray-300"
                  >
                    Private Status Pages
                  </Switch.Label>
                </div>
              </Switch.Group>
            </div>

          </div>

          <div className="space-y-4 max-w-xs mx-auto">
            <a
              href={link}
              className="block w-full rounded-md bg-brand-600 px-3 py-2 text-center text-base font-semibold text-white shadow-sm hover:bg-brand-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
            >
              {showDemoAsPrice && "Request demo" || "Start Your Free Trial Today"}
            </a>

            <p className="text-[12px] max-w-[250px] mx-auto text-gray-400">
                Easy to get started
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
